module.exports = __webpack_public_path__ + "img/badge_color_she-holistic.ab55de02.svg";